module.exports = __webpack_public_path__ + "img/CHANGE_COLOR.3c064464.svg";